// Copyright (c) StrangeBee 2023

import { ReactElement, memo } from 'react';
import { classList } from '@Helpers/className';

interface DocPreviewProps {
    src: string;
    className?: string;
}

export const PDFPreview = memo(
    ({ src, className }: DocPreviewProps): ReactElement => (
        <embed className={classList('PDFPreview', className)} type="application/pdf" src={src} title="doc" />
    ),
);
